<template>
  <div class="input-tags">
    <span v-for="(tag, index) in tags" :key="tag" class="badge tag">
      <span class="">
        {{ tag }}
      </span>
      <img
        class="remove"
        src="/static/icons/close-thin.svg"
        alt="remove"
        @click="removeTag(index)"
      />
    </span>
    <input
      id=""
      v-model="newTag"
      type="text"
      class="add-tag"
      name=""
      placeholder="เพิ่ม Tag ที่นี่..."
      @keyup.enter="setTag"
      @keyup.space="setTag"
    />
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      newTag: "",
    }
  },
  methods: {
    setTag() {
      const dup = this.checkDupicate(this.newTag)
      if (!dup && this.newTag) {
        this.$emit("updateTag", [...this.tags, this.newTag])
        this.newTag = ""
      }
    },
    removeTag(index) {
      this.$emit(
        "updateTag",
        this.tags.filter((_, i) => i !== index),
      )
    },
    checkDupicate(input) {
      for (let i = 0; i < this.tags.length; i += 1) {
        if (input === this.tags[i]) {
          return true
        }
      }
      return false
    },
  },
}
</script>

<style scoped>
.tag {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  background-color: #fff;
  padding: 3px 10px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  margin: 0 5px 5px 0;
}
.add-tag {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  width: 120px;
  border: none;
}
.media-body {
  width: auto;
}
.remove {
  opacity: 0.6;
  height: 20px;
  margin-bottom: 2px;
}
</style>
